module.exports = __webpack_public_path__ + "img/yama-banner.1c411e81.png";